import { Field, LinkField } from "@sitecore-jss/sitecore-jss-nextjs";
import { AccordionButton, AccordionItem, AccordionPanel, Box, Divider } from "@chakra-ui/react";
import { spacing } from "themes/foundations/spacings";
import BundleIcon from "components/ui/BundleIcon";
import SCRichText from "components/sc/SCRichText";
import SCText from "components/sc/SCText";
import SCLink from "components/sc/SCLink";
import { gtmCTAEvent } from "components/head/GTMTracking";
interface Fields {
    Headline: Field<string>;
    Text: Field<string>;
    CTA: LinkField;
}

export type AccordionElementProps = {
    fields: Fields;
};

const AccordionElement = (props: AccordionElementProps) => {
    return (
        <AccordionItem sx={{ counterIncrement: "line-number" }}>
            {({ isExpanded }) => (
                <Box
                    sx={{
                        ".chakra-collapse": {
                            opacity: "1!important", // Fix to override inline opacity transition from chakra-ui
                        },
                    }}
                >
                    <AccordionButton
                        onClick={() => {
                            gtmCTAEvent(
                                props.fields?.Headline.value,
                                isExpanded ? "Foldin accordion" : "Foldout accordion"
                            );
                        }}
                    >
                        <Box
                            as="span"
                            minWidth={[spacing.sp28 as string, null, null, spacing.sp168 as string]}
                            _before={{ content: "counter(line-number, decimal-leading-zero)" }}
                        ></Box>
                        <SCText as="span" size="h3" textField={props.fields?.Headline} />
                        <Box
                            as="span"
                            marginLeft="auto"
                            display={"flex"}
                            mt={{ base: "sp4", lg: "0" }}
                            alignItems={{ lg: "center" }}
                        >
                            {isExpanded ? (
                                <BundleIcon size={["md", null, null, "lg"]} name="Remove" />
                            ) : (
                                <BundleIcon size={["md", null, null, "lg"]} name="Add" />
                            )}
                        </Box>
                    </AccordionButton>
                    <AccordionPanel>
                        <SCRichText richTextField={props.fields?.Text} />
                        <SCLink
                            fontWeight="medium"
                            size="2xs"
                            letterSpacing="wide"
                            py="sp12"
                            variant={"underlineLink"}
                            linkField={props.fields?.CTA}
                        />
                    </AccordionPanel>
                    <Divider height="1" bg="brand.lightGray" />
                </Box>
            )}
        </AccordionItem>
    );
};
export default AccordionElement;
